<div *ngIf="patient" id="root" fileDnd (fileDropped)="!isLoading && fileDropped($event)">
  <div id="modal-header">
    <h2 class="title">Partager des documents <b>{{patient && patient.fullName ? 'avec ' + patient.fullName : ''}}</b></h2>
    <p class="subtitle">Vous pouvez sélectionner jusqu'à 5 documents maximum.</p>
  </div>
  <hr />
  <div id="modal-content-wrapper">
    <div id="files-wrapper">
      <msd-document-file-cell (onDelete)="deleteFile(index)"
                              *ngFor="let doc of models; let index = index"
                              [completed]="doc.completed"
                              [deletable]="!isLoading"
                              [error]="doc.error"
                              [fileName]="doc.fileName"
                              [progress]="(doc.progress$ | async) ?? -1">
      </msd-document-file-cell>
    </div>
    <div *ngIf="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    <div id="category-wrapper">
      <div>
        <h3>Associer une catégorie :</h3>
        <p class="subtitle">Pour une meilleure organisation les fichiers sont classés par catégorie.</p>
      </div>
      <div class="dropdown" dropdown>
        <button id="category-button" type="button" class="btn btn-outline" dropdownToggle>
          <span id="category-label">{{ getCategoryLabel(category) }}</span>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
          <li *ngFor="let cat of categories" [id]="cat.value" role="menuitem" (click)="selectCategory(cat.value)"><span class="dropdown-item">{{cat.label}}</span></li>
        </ul>
      </div>
    </div>

    <div id="scheduled-date-wrapper">
      <div class="form-check form-switch">
        <input class="form-check-input" [(ngModel)]="isScheduled" type="checkbox" id="scheduled-switch">
        <label class="form-check-label" for="scheduled-switch">Programmer la date et l’heure du partage</label>
      </div>
    </div>
    <div id="scheduled-date-selector-wrapper" *ngIf="isScheduled">
      <div id="date-wrapper">
        <label>Date</label>
        <input id="date-input" [(ngModel)]="scheduledDate" type="text" placeholder="Choisissez une date"
               class="form-control" [bsConfig]="{ containerClass: 'theme-blue', adaptivePosition: true }"
               bsDatepicker>
      </div>

      <div id="hour-wrapper">
        <label>Heure</label>
        <input id="hour-input" [(ngModel)]="scheduledTime" type="time" placeholder="Choisissez une heure"
               class="form-control">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <input #fileInput hidden id="fileInput" type="file" [multiple]="true" [accept]="acceptedFiles" (change)="fileSelected($event)">
    <button id="add-file-button" [disabled]="isLoading" (click)="fileInput.click()" type="button" [disabled]="isLoading"
      class="btn btn-secondary">
      Ajouter
      <i i-bs name="box-arrow-in-down" width="15" height="15"></i>
    </button>
    <div class="actions-wrapper">
      <button id="cancel-button" (click)="hideModal()" [disabled]="isLoading" type="button"
        class="btn btn-outline-primary btn-outline text-only">
        Annuler
      </button>
      <button id="share-button" [disabled]="models.length === 0 || !filesValidated || !category || isLoading || !enableScheduling()" (click)="uploadDocument()" type="button" class="btn btn-primary btn-gradient text-icon">
        <ng-container *ngIf="isLoading; else validateButton">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </ng-container>
        <ng-template #validateButton>
          Partager
          <i i-bs name="plus-square" width="15" height="15"></i>
        </ng-template>
      </button>
    </div>
  </div>

  <div class="drop-zone">
    <span>Déposer les nouveaux documents partagés</span>
  </div>
</div>



